import axios from "axios";

const BASE_URL = import.meta.env.VITE_BACKEND_URL;

export const getActiveQueries = () =>
    axios.get(`${BASE_URL}/api/contramatic/admin/database/activeQueries`);

export const cancelQuery = (pid) =>
    axios.post(`${BASE_URL}/api/contramatic/admin/database/cancelQuery/${pid}`);